import React, { useEffect, useState, useCallback, useContext, useRef } from "react";
import api, { BASE_URL } from "../../Utils/api";
import TiposFornecedorModal from "./TiposFornecedorModal";
import ConfiguracoesCamposModal from "../Configuracoes/ConfiguracoesCampos/ConfiguracoesCamposModal";
import GridPadrao from "../GridPadrao/GridPadrao";
import PageHeader from "../PageHeader/PageHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalContext } from "../../Utils/GlobalContext";
import { useFeedback } from "../Generals/Feedback/FeedbackContext";


function TiposFornecedor() {
  const { toast, confirm } = useFeedback();
  const [tiposFornecedor, setTiposFornecedor] = useState([]);
  const [selectedFornecedor, setSelectedFornecedor] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showConfigCamposModal, setShowConfigCamposModal] = useState(false);
  const [tccFornecedorId, setTccFornecedorId] = useState(null);

  const token = localStorage.getItem("authToken");
  const exclusoesEmAndamento = useRef(new Set());
  const permiteEdicao = "N";

  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");

  const columns = [
    { Header: "Descrição", accessor: "descricao" },
    { Header: "Situação",  accessor: "situacao" },
  ];

  // Resolve o TCC correspondente a Fornecedores pelo nome/descrição.
  useEffect(() => {
    if (!entidadeID || !token) return;
    api
      .get(`${BASE_URL}/api/configuracaoCampos/ListarTiposConfiguracoesCampos/${entidadeID}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const lista = Array.isArray(res.data?.data) ? res.data.data : [];
        const match = lista.find((t) =>
          (t.nome || t.descricao || "").toLowerCase().includes("fornecedor")
        );
        setTccFornecedorId(match?.id ?? null);
      })
      .catch(() => setTccFornecedorId(null));
  }, [entidadeID, token]);

  const handleOpenConfigCampos = () => {
    if (tccFornecedorId != null) setShowConfigCamposModal(true);
  };

  const fetchTiposFornecedor = useCallback(() => {
    api
      .get(`${BASE_URL}/api/tiposEmpresa/ListarTiposEmpresa/${entidadeID}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const lista = Array.isArray(response.data?.data) ? response.data.data : [];
        const tiposComPermissao = lista.map((tipo) => ({
          ...tipo,
          permiteEdicao,
        }));
        setTiposFornecedor(tiposComPermissao);
      })
      .catch((error) => {
        console.error("Erro ao buscar os tipos de fornecedor:", error);
      });
  }, [token, entidadeID, permiteEdicao]);

  useEffect(() => {
    fetchTiposFornecedor();
  }, [fetchTiposFornecedor]);

  const handleEdit = (fornecedor) => {
    setSelectedFornecedor(fornecedor);
    setShowModal(true);
  };

  const handleAdd = () => {
    setSelectedFornecedor(null);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedFornecedor(null);
  };

  const handleExcluir = async (fornecedor) => {
    if (exclusoesEmAndamento.current.has(fornecedor.id)) return;
    exclusoesEmAndamento.current.add(fornecedor.id);

    try {
      const ok = await confirm(`Tem certeza que deseja excluir o tipo "${fornecedor.descricao}"?`);
      if (!ok) return;

      await api.delete(
        `${BASE_URL}/api/tiposEmpresa/ExcluirTiposEmpresa/${fornecedor.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchTiposFornecedor();
    } catch (error) {
      if (error.response?.status === 409) {
        toast.error(error.response.data?.message || "Este tipo de fornecedor está sendo utilizado.");
        return;
      }

      console.error("Erro ao excluir tipo de fornecedor:", error);
      toast.error(error.response?.data?.message || "Erro ao excluir. Tente novamente.");
    } finally {
      exclusoesEmAndamento.current.delete(fornecedor.id);
    }
  };

  return (
    <div>
      <PageHeader titulo="Cadastro de Tipos de Fornecedor" path="/TiposFornecedor" />
      <GridPadrao
        columns={columns}
        data={tiposFornecedor}
        onEdit={(configuracao) => handleEdit(configuracao, permiteEdicao)}
        onAdd={handleAdd}
        addDataTour="tipos-fornecedor-adicionar"
        onInactivate={handleExcluir}
        onConfigCampos={tccFornecedorId != null ? handleOpenConfigCampos : undefined}
      />

      <TiposFornecedorModal
        show={showModal}
        handleClose={handleClose}
        fornecedor={selectedFornecedor}
        fetchTiposFornecedor={fetchTiposFornecedor}
      />

      <ConfiguracoesCamposModal
        show={showConfigCamposModal}
        handleClose={() => setShowConfigCamposModal(false)}
        configuracao={tccFornecedorId != null ? { id: tccFornecedorId } : null}
        fetchConfiguracoes={fetchTiposFornecedor}
      />
    </div>
  );
}

export default TiposFornecedor;
